import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: `/:code`,
    name: 'Presentation',
    component: function() {
      return import('../views/Presentation')
    }
  },
  {
    path: `/:code/watch`,
    name: 'Presentation Viewer',
    component: function() {
      return import('../views/PresentationWatch')
    }
  },
  {
    path: `/:code/popout`,
    name: 'Presentation Viewer',
    component: function() {
      return import('../views/PresentationWatchPopout')
    }
  },
  {
    path: `/:code/chat`,
    name: 'Presentation Chat Popout',
    component: function() {
      return import('../views/PresentationChat')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
